module.exports = __webpack_public_path__ + "static/media/iphone.f3c4bf13.png";